import dateTimeFilter from '@/filters/dateTimeFilter';

export default {
  install(Vue) {
    Vue.filter('dateTimeFilter', dateTimeFilter);
  },
};
